import { createContext} from "react";

// const AuthContext = React.createContext();
const AuthContext = createContext();

export default AuthContext;